// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".plot_container_pane {\n    margin: 1%;\n    width: 95%;\n    height: 90%;\n    justify-self: center;\n    align-self: center;\n    background-color: white;\n    padding: 1%;\n    /*border: 1px solid blue;*/\n}\n\n.plot {\n    height: 100%;\n    width: 100%;\n}\n\n.voltage_label {\n    color: blue;\n    position: relative;\n    font-size: 10px;\n    left: 35%;\n    bottom: 63.5px;\n}", ""]);
// Exports
module.exports = exports;
